import { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";

import constants from "../../assets/constants.js";
import { helperGetIsoDate, OmniStringToDate } from "../../utils/helpers.js";
import ConversationTopicsGraph from "../graphing/botpressConversationsGraph.js";
import OmniDateRangePopover from "../ui/omniDateRangePopover.js";
import Widget from "../ui/widget.js";
import WidgetContent from "../ui/widgetContent.js";
import WidgetSkeleton from "../ui/widgetSkeleton.js";
import WidgetTitle from "../ui/widgetTitle.js";

const BotpressConvesationsAnalytics = ({
  chatsAnalysis,
  chatsAnalysisLoading,
  botpressGraphType = constants.botpressGraphTypes.conversationTopicsGraph,
  colorIndex = 0,
  widgetSize = "medium",
  minHeight = "333px",
}) => {
  const [localStartDate, setLocalStartDate] = useState(new Date(helperGetIsoDate(29, true, true))); //7 days
  const [localEndDate, setLocalEndDate] = useState(new Date(helperGetIsoDate(0, false, true)));

  //   const analyticsRecords = useMemo(() => {
  //     if (!analytics) return [];
  //     const localStartString = localStartDate.toISOString();
  //     let localRecords = analytics.filter(obj => obj.startDateTimeUtc >= localStartString);
  //     if (isDateToday(localEndDate)) {
  //       const localIso = localEndDate.toISOString();
  //       localRecords = localRecords.filter(obj => obj.endDateTimeUtc <= localIso);
  //     }
  //     return localRecords;
  //   }, [analytics, localEndDate, localStartDate]);

  const [titleText, setTitleText] = useState("Loading..");

  useEffect(() => {
    setTitleText(botpressGraphType);
  }, [botpressGraphType]);

  const onRangeChange = (newStartDate, newEndDate) => {
    // if (newStartDate < analyticsStartDate) {
    //   loadAnalyticsRequest({
    //     analyticsStartDate: new Date(OmniStringToDate(newStartDate)),
    //   });
    // }
    setLocalStartDate(new Date(OmniStringToDate(newStartDate)));
    setLocalEndDate(new Date(OmniStringToDate(newEndDate)));
  };

  return (
    <Widget widgetSize={widgetSize} minHeight={minHeight}>
      <WidgetTitle title={"Analytics"} text={titleText}>
        {/* <OmniDateRangePopover
          analyticsStartDate={localStartDate}
          analyticsEndDate={localEndDate}
          onRangeChange={onRangeChange}
          disabled={true}
        /> */}
      </WidgetTitle>

      {chatsAnalysisLoading && <WidgetSkeleton />}
      {!chatsAnalysisLoading && (
        <WidgetContent>
          <ConversationTopicsGraph
            chatsAnalysis={chatsAnalysis}
            botpressGraphType={botpressGraphType}
            colorIndex={colorIndex}
          />
        </WidgetContent>
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  chatsAnalysisLoading: state.botpressSession.chatsAnalysisLoading,
  chatsAnalysis: state.botpressSession.chatsAnalysis,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(BotpressConvesationsAnalytics);
